module.exports = __webpack_public_path__ + "static/media/logFlowRate.d9454928.svg";